import { Injectable } from "@angular/core";
import { v4 as uuid } from "uuid";

@Injectable({
    providedIn: "root",
})
export class ConversationService {
    private conversationId: string;
    private mostRecentCorrelationId: string;

    getConversationId() {
        if (this.conversationId) {
            return this.conversationId;
        }

        this.conversationId = uuid();

        return this.conversationId;
    }

    getCorrelationId() {
        this.mostRecentCorrelationId = uuid();

        return this.mostRecentCorrelationId;
    }

    getMostRecentCorrelationId() {
        return this.mostRecentCorrelationId;
    }
}
